module.exports = __webpack_public_path__ + "static/media/header-about-mobile.8652612d.png";